import { render, staticRenderFns } from "./labelInputForSupervision.vue?vue&type=template&id=82b77086&scoped=true"
import script from "./labelInputForSupervision.vue?vue&type=script&lang=js"
export * from "./labelInputForSupervision.vue?vue&type=script&lang=js"
import style0 from "./labelInputForSupervision.vue?vue&type=style&index=0&id=82b77086&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82b77086",
  null
  
)

export default component.exports